import { useMutation } from '@tanstack/react-query';
import { admitPatient } from '../services/patient';

const useAdmitPatient = () => {
    const admitPatientMutation = useMutation({
        mutationFn: ({ patientId, admissionData }) => admitPatient(patientId, admissionData),
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Error admitting patient:', error);
        }
    });
    return admitPatientMutation;
}

export default useAdmitPatient; 